module.exports = __webpack_public_path__ + "static/media/newsletter-may-2021-blessings.f66acd7a.jpg";